import { formatDayShort } from '@/shared/format/dates';

const WIDTH = 300;
const HEIGHT = 64;
const PADDING = 6;

/**
 * La línea del peso en el tiempo.
 *
 * Sin ejes, sin grilla y sin color de dirección: subir o bajar no es bueno ni malo por sí mismo,
 * y pintar la pendiente de verde o rojo sería emitir el juicio que RN-09 prohíbe. La forma dice
 * lo que pasó; qué significa lo decide la persona.
 */
export function Sparkline({ points }: { points: Array<{ date: string; value: number }> }) {
  if (points.length < 2) {
    return null;
  }

  const values = points.map((point) => point.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  // Un rango de cero dividiría por cero: si el peso no se movió, la línea va al medio.
  const span = max - min || 1;

  const coordinates = points.map((point, index) => {
    const x = PADDING + (index / (points.length - 1)) * (WIDTH - PADDING * 2);
    const y = HEIGHT - PADDING - ((point.value - min) / span) * (HEIGHT - PADDING * 2);
    return { x, y };
  });

  const last = coordinates[coordinates.length - 1];
  const first = points[0];
  const middle = points[Math.floor(points.length / 2)];
  const latest = points[points.length - 1];

  return (
    <div className="stack" style={{ gap: 'var(--space-1)' }}>
      <svg
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        width="100%"
        height={HEIGHT}
        role="img"
        aria-label={`Peso desde ${formatDayShort(first?.date ?? '')} hasta ${formatDayShort(latest?.date ?? '')}`}
      >
        <polyline
          points={coordinates.map((point) => `${point.x},${point.y}`).join(' ')}
          fill="none"
          stroke="var(--brand)"
          strokeWidth={2.4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {last !== undefined && <circle cx={last.x} cy={last.y} r={4} fill="var(--brand)" />}
      </svg>

      <div className="row-between nano muted numeric">
        <span>{formatDayShort(first?.date ?? '')}</span>
        <span>{formatDayShort(middle?.date ?? '')}</span>
        <span>{formatDayShort(latest?.date ?? '')}</span>
      </div>
    </div>
  );
}
